/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { adaptivePlannerItemSchema } from './adaptivePlannerItemSchema';
import { scenarioItemMetricsSchema } from './scenarioItemMetricsSchema';
import { scenarioItemSchema } from './scenarioItemSchema';

export const timeLineItemSchema = z.object({
  get item() {
    return adaptivePlannerItemSchema;
  },
  get scenarioItem() {
    return scenarioItemSchema;
  },
  get scenarioItemMetrics() {
    return z.union([scenarioItemMetricsSchema, z.null()]).optional();
  },
});
